module.exports = __webpack_public_path__ + "img/grid (1).8f32a85b.png";